import { FuseNavigationItem } from '@fuse/components/navigation';
import { Permissions } from 'app/core/auth/permissions.constants';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'nav.supply_chain.dashboard',
        type: 'basic',
        link: '/supply-chain/dashboard',
        icon: 'heroicons_outline:chart-bar',
        meta: { permission: Permissions.DashboardView },
    },
    // {
    //     id: 'po-upload',
    //     title: 'nav.supply_chain.po_upload',
    //     type: 'basic',
    //     link: '/supply-chain/po-upload',
    //     icon: 'heroicons_outline:document-arrow-up',
    //     meta: { permission: Permissions.PoUpload },
    // },
    {
        id: 'warehouses',
        title: 'nav.supply_chain.warehouses',
        type: 'basic',
        link: '/supply-chain/warehouses',
        icon: 'heroicons_outline:building-office-2',
        meta: { permission: Permissions.WarehouseListView },
    },
    {
        id: 'reports',
        title: 'nav.supply_chain.reports_group',
        type: 'collapsable',
        icon: 'heroicons_outline:document-chart-bar',
        children: [
            {
                id: 'reports-kpi',
                title: 'nav.supply_chain.reports',
                type: 'basic',
                link: '/supply-chain/reports',
                icon: 'heroicons_outline:chart-bar-square',
                meta: { permissions: [Permissions.ReportsDashboardView, Permissions.ReportsNonConformitiesByCategory] },
            },
            {
                id: 'reports-invoicing',
                title: 'nav.supply_chain.reports_invoicing',
                type: 'basic',
                link: '/supply-chain/reports/invoicing-status',
                icon: 'heroicons_outline:banknotes',
                meta: { permission: Permissions.ReportsInvoicingStatus },
            },
        ],
    },
    {
        id: 'lga',
        title: 'nav.supply_chain.lga',
        type: 'basic',
        link: '/supply-chain/lga',
        icon: 'heroicons_outline:clipboard-document-list',
        meta: { permission: Permissions.LgaListView },
    },
    {
        id: 'non-conformities',
        title: 'nav.supply_chain.non_conformities',
        type: 'basic',
        link: '/supply-chain/non-conformities',
        icon: 'heroicons_outline:exclamation-triangle',
        meta: { permission: Permissions.NonConformityListView },
    },
    {
        id: 'qr-generate',
        title: 'nav.supply_chain.qr_generate',
        type: 'basic',
        link: '/supply-chain/qr-code/generate',
        icon: 'heroicons_outline:qr-code',
        meta: { permission: Permissions.QrCodeGenerate },
    },
    {
        id: 'qr-scanner',
        title: 'nav.supply_chain.qr_scanner',
        type: 'basic',
        link: '/supply-chain/qr-code/scanner',
        icon: 'heroicons_outline:camera',
        meta: { permission: Permissions.QrScannerScan },
    },
    {
        id: 'documentation',
        title: 'nav.documentation',
        type: 'basic',
        link: '/documentation',
        icon: 'heroicons_outline:book-open',
        meta: { permission: Permissions.DocumentationView },
    },
    // Admin
    {
        id: 'admin',
        title: 'nav.admin.main',
        type: 'collapsable',
        icon: 'heroicons_outline:user',
        meta: { permission: Permissions.UserManagementViewList },
        children: [
            {
                id: 'users-list',
                title: 'nav.admin.users-list',
                type: 'basic',
                link: '/admin/users-list',
                icon: 'heroicons_outline:users',
                meta: { permission: Permissions.UserManagementViewList },
            },
            {
                id: 'permissions',
                title: 'nav.admin.permissions',
                type: 'basic',
                link: '/admin/permissions',
                icon: 'heroicons_outline:shield-check',
                meta: { permission: Permissions.UserManagementManageRoles },
            },
            {
                id: 'configurations',
                title: 'nav.admin.configurations',
                type: 'basic',
                link: '/admin/configurations',
                icon: 'heroicons_outline:cog-6-tooth',
                meta: { permission: Permissions.AlertSettingsManage },
            },
            {
                id: 'logs',
                title: 'nav.admin.logs',
                type: 'basic',
                link: '/admin/logs',
                icon: 'heroicons_outline:document-text',
                meta: { permission: Permissions.ApplicationLogsView },
            },
        ],
    },
];

// |--------------------------------------------------------------------------|
// |                                                                          |
// |                            NOT USED MENUS                                |
// |                                                                          |
// |--------------------------------------------------------------------------|

export const compactNavigation: FuseNavigationItem[] = [];
export const futuristicNavigation: FuseNavigationItem[] = [];
export const horizontalNavigation: FuseNavigationItem[] = [];
